import './shared.scss';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import CartItem from './cart-item';
import IProduct from '../interfaces/IProduct';
import IDelivery from '../interfaces/IDelivery';
import * as React from 'react';
import { ActionButton, ActionButtonSmall } from '../utils/action-button';
import { Add } from '@mui/icons-material';
import ScrollContainer from 'react-indiana-drag-scroll';

export default function Sidebar(props: { deliveryOptions?: IDelivery; cartItems: IProduct[]; totalPrice: any; setCartState?: any; drinks?: IProduct[]; addItem?: any }) {
    const cartItems = props.cartItems;
    const deliveryOptions = props.deliveryOptions;
    const totalPrice = props.totalPrice;
    const setCartState = props.setCartState;
    const drinks = props.drinks;

    const location = useLocation();
    const [isOrderPage, setIsOrderPage] = useState(true);
    const minAmountExceeded = totalPrice - deliveryOptions?.price! < deliveryOptions?.amountMin!;

    const sidebar = {
        maxWidth: '340px',
        minWidth: '340px'
    }

    const divRef = useRef<null | HTMLDivElement>(null);
    const scrollToBottom = () => {
        divRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }

    const handleAdd = (prod: IProduct) => {
        let newProd = {...prod, quantity: 1}
        props.addItem(newProd);
    }

    const cartHasDrinks = (): boolean => {
        let drinksInCart: IProduct[] = [];
        cartItems.map(
            item => {
                drinks?.map(drink => {
                    if (item.id === drink.id) {
                        drinksInCart.push(drink);
                    }
                })
            }
        )

        return drinksInCart.length > 0;
    }

    useEffect(() => {
        if (location.pathname === '/payment') {
            setIsOrderPage(false);
        }

        scrollToBottom();
    }, [location.pathname, cartItems]);

    return (
        <div className="sidebar-outer">
            <div style={sidebar} className="sidebar">
                <div className="sidebar-inner">
                    <div className="sidebar-content">
                        <h2 className="shopping-cart-title z-50">Winkelmandje 🛒</h2>

                        <div className="flex-1">
                            {cartItems.length === 0 &&
                                <div className="empty-cart">Vul het mandje om verder te gaan</div>}
                            {cartItems.length > 0 && cartItems.map((product: IProduct, index: number) => <CartItem
                                cart={cartItems} setCartState={setCartState} product={product} key={index}
                                isOrderPage={isOrderPage}/>)}
                        </div>
                        {cartItems.length > 0 &&
                            <div className="order-payment-details">
                                <div className="flex flex-col pb-4">
                                    {minAmountExceeded &&
                                        <>
                                            <div className="amount-remaining">
                                                <div>Benodigd bedrag om het bestelbedrag te bereiken&nbsp;</div>
                                                <div
                                                    className="font-semibold">€{(deliveryOptions?.amountMin! - (totalPrice - deliveryOptions?.price!)).toFixed(2).replace('.', ',')}</div>
                                            </div>
                                            <p className="min-amount-warning">Ons minimum bestelbedrag bedraagt
                                                €{deliveryOptions?.amountMin.toFixed(2).replace('.', ',')} (excl.
                                                bezorgkosten) voordat u kunt bestellen</p>
                                        </>
                                    }

                                    {isOrderPage && !cartHasDrinks() &&
                                        <div className="extra-item-section">
                                            <p className="text-xs text-gray-500">Geniet van een koel drankje voor bij de maaltijd 🥤</p>

                                            <ScrollContainer className="extra-item-selector" horizontal={true}>
                                                {drinks?.map(drink =>
                                                    <div key={drink.id} className="grow px-1">
                                                        <ActionButtonSmall
                                                            onClick={() => handleAdd(drink)}
                                                            variant="contained"
                                                            color="secondary">
                                                            <Add fontSize="small"/> {drink.name}
                                                        </ActionButtonSmall>
                                                    </div>
                                                )
                                                }
                                            </ScrollContainer>
                                        </div>
                                    }
                                    <div className="flex">
                                        <div className="flex-1">
                                            Bezorgkosten:
                                        </div>
                                        <div className="euro-amount">
                                            €{deliveryOptions?.price.toFixed(2).replace('.', ',')}
                                        </div>
                                    </div>
                                    <div className="flex font-bold pt-1">
                                        <div className="flex-1">
                                            Totaal:
                                        </div>
                                        <div className="euro-amount">
                                            €{totalPrice.toFixed(2).replace('.', ',')}
                                        </div>
                                    </div>
                                </div>
                                {isOrderPage &&
                                    <ActionButton
                                        component={Link}
                                        disabled={minAmountExceeded}
                                        to={`payment`}
                                        state={{cartItems}}
                                        variant="contained"
                                        color="secondary">
                                        💸 Afrekenen (€{totalPrice.toFixed(2).replace('.', ',')})
                                    </ActionButton>
                                }
                            </div>
                        }
                        <div ref={divRef}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}